import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useWaMsg, waUrl } from "@/lib/waTemplates";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Droplets, MessageCircle, Check } from "lucide-react";

const fmtD = (s) => (s ? new Date(`${s}T12:00:00`).toLocaleDateString("pt-BR") : "");

export function OilReminders() {
  const [list, setList] = useState(null);
  const waMsg = useWaMsg();
  const load = () => api.get("/crm/oil-reminders").then(({ data }) => setList(data)).catch(() => setList([]));
  useEffect(() => { load(); }, []);
  const done = async (it) => { try { await api.post(`/crm/oil-reminders/${it.order_id}/contacted`); toast.success("Marcado como contatado"); load(); } catch (e) { toast.error(formatApiError(e)); } };
  if (!list || list.length === 0) return null;
  const today = new Date().toISOString().slice(0, 10);
  return (
    <section data-testid="oil-reminders" className="rounded-2xl border border-card2-border bg-card2 p-5">
      <h2 className="flex items-center gap-2 font-display text-lg font-bold uppercase text-zinc-100 mb-3"><Droplets className="h-4 w-4 text-amber-brand" /> Troca de óleo <span className="text-sm text-zinc-500">({list.length})</span></h2>
      <div className="divide-y divide-zinc-800">{list.map((it) => {
        const km = `${Number(it.next_km).toLocaleString("pt-BR")} km`;
        const text = waMsg("oil", { cliente: it.customer_name || "", placa: it.plate || "", modelo: it.model || "", km, data: fmtD(it.next_date) });
        return (
          <div key={it.order_id} data-testid={`oil-rem-${it.order_id}`} className="py-2 flex flex-wrap items-center justify-between gap-2">
            <div className="min-w-0">
              <div className="text-sm text-zinc-100 font-bold">{it.customer_name || "—"} · <span className="font-mono">{it.plate}</span></div>
              <div className={`text-xs ${it.next_date < today ? "text-red-400" : "text-zinc-400"}`}>Próxima: {km} ou {fmtD(it.next_date)}{it.contacted_at ? " · contatado" : ""}</div>
            </div>
            <div className="flex gap-2">
              {it.customer_phone && <a data-testid={`oil-wa-${it.order_id}`} href={waUrl(it.customer_phone, text)} target="_blank" rel="noopener noreferrer" className="h-8 px-2 inline-flex items-center gap-1 rounded-md bg-emerald-600 text-white text-xs"><MessageCircle className="h-3.5 w-3.5" /> WhatsApp</a>}
              {!it.contacted_at && <Button data-testid={`oil-done-${it.order_id}`} size="sm" variant="outline" onClick={() => done(it)} className="h-8 bg-zinc-900 border-zinc-800"><Check className="h-3.5 w-3.5 mr-1" /> Contatado</Button>}
            </div>
          </div>
        );
      })}</div>
    </section>
  );
}
